import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cleanProductCode'
})
export class CleanProductCodePipe implements PipeTransform {

    transform(value: string, args?: any): any {
        return value.replace(/^0+/, '');
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/clean-product-code.pipe.ts